export default __webpack_public_path__ + "static/media/dumpster.fbd15e1f.jpg";